// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import React from 'react';

import { Router, Route } from 'react-router-dom';

import type { History } from 'history';
import { ToastContainer } from 'react-toastify';
import { createPortal } from 'react-dom';

interface ContextProps {
  children: string | React.FunctionComponent<any> | React.ComponentClass<any, any>;
  history: History;
  path: string;
  scope: string;
}

const Context = ({
  children,
  history,
  path,
  scope,
}: ContextProps) => (
  <>
    {scope === 'content' && createPortal(<ToastContainer />, document.body)}
    <Router history={history}>
      <Route path={path}>
        {
          React.isValidElement(children)
            ? children
            : React.createElement(children)
        }
      </Route>
    </Router>
  </>
);

export default Context;
